import { Link } from 'react-router-dom';
import styles from './CtaComp.module.css';

export default function CtaComp({
  kicker = '',
  heading = '',
  description = '',
  buttonLabel = '',
  buttonLink = '',
}) {
  if (!heading) {
    return null;
  }

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.ctaPanel}>
          {kicker ? <span className={styles.kicker}>{kicker}</span> : null}
          <h2>{heading}</h2>
          {description ? <p>{description}</p> : null}
          {buttonLabel && buttonLink ? (
            <Link to={buttonLink} className={styles.ctaButton}>
              {buttonLabel}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
}
